import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '@/context/ThemeContext';

export default function ModeTransition() {
  const { isTransitioning, microCopy, theme } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <AnimatePresence>
      {isTransitioning && (
        <motion.div
          className="mode-transition-overlay flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: isMobile ? 0.8 : 1.5 }}
          style={{
            background: isMobile
              // Mobile: simple crossfade (PRD: 0.8s)
              ? (theme === 'dark'
                ? 'rgba(13,13,13,0.95)'
                : 'rgba(250,250,249,0.95)')
              // Desktop: radial wipe effect (PRD: 1.5s)
              : (theme === 'dark'
                ? 'radial-gradient(circle at center, rgba(0,255,133,0.06) 0%, rgba(13,13,13,0.97) 60%)'
                : 'radial-gradient(circle at center, rgba(250,250,249,0.95) 0%, rgba(240,237,232,0.97) 60%)'),
          }}
        >
          {/* Desktop: radial clip-path animation */}
          {!isMobile && (
            <motion.div
              className="absolute inset-0"
              initial={{
                clipPath: theme === 'light'
                  ? 'circle(0% at 50% 50%)'   // Light→Dark: shrink from center
                  : 'circle(0% at 50% 50%)',   // Dark→Light: expand from center
              }}
              animate={{
                clipPath: 'circle(150% at 50% 50%)',
              }}
              transition={{ duration: 1.5, ease: 'easeInOut' }}
              style={{
                background: theme === 'dark'
                  ? 'rgba(13,13,13,0.95)'
                  : 'rgba(250,250,249,0.95)',
              }}
            />
          )}

          {/* Micro-copy text */}
          {microCopy && (
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="font-heading text-lg md:text-xl font-medium tracking-wide relative z-10"
              style={{ color: 'var(--accent-primary)' }}
            >
              {microCopy}
            </motion.p>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
